import React, { useContext, useEffect, useState } from 'react';
import 'assets/styles/common.scss';
import { FormattedMessage, useIntl } from 'react-intl';
import { Col, Row, Stack } from 'react-bootstrap';
import { LocaleContext } from 'routes/Router';
import ArrowLeftIcon from 'assets/images/arrow-left.png';
import AddIcon from 'assets/images/Dashboard/add.png';
import CheckBoxInput from 'components/common/Input/CheckBoxInput';
import LabelWithInput from 'components/common/Input/LabelWithInput';
import ReusableButton from 'components/common/Button';
import CustomTabs from 'components/common/CustomTabs';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import moment from 'moment';
import { updateAppointmentsCallAPI } from 'store/ProviderAdmin/updateAppointments/action';
import ToastNotification from 'components/common/Toast';
import { addAppointmentsCallAPI } from 'store/ProviderAdmin/addAppointments/action';
import CircularProgress from '@mui/material/CircularProgress';
import DeleteIcon from 'assets/images/Category/DeleteIcon.png';
import SelectInput from 'components/common/Input/SelectInput';
import { getUserRole } from 'utils/general';
import { getAppointmentsCallAPI } from 'store/ProviderAdmin/getAppointments/action';
import { ShimmerBox } from 'components/common/Shimmer';

const EditSchdeule = () => {
  const { locale } = useContext(LocaleContext);
  const [conf, setConf] = ToastNotification();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const intl = useIntl();
  const [tab, setTab] = useState(0);
  const [copyValue, setCopyValue] = useState('');
  const { state } = useLocation();
  const userRole = getUserRole();

  const selectedDay = new Date().toLocaleDateString('en-US', {
    weekday: 'long',
  });

  const getAppointmentsData = useSelector(
    (state) => state?.getAppointmentsReducer?.data?.data
  );
  const getAppointmentsLoading = useSelector(
    (state) => state?.getAppointmentsReducer?.loading
  );

  const [appointmentsListData, setAppointmentsListData] = useState(
    getAppointmentsData ? getAppointmentsData : []
  );

  const addAppointmentLoader = useSelector(
    (state) => state?.addAppointmentsReducer?.loading
  );
  const updateAppointmentLoader = useSelector(
    (state) => state?.updateAppointmentsReducer?.loading
  );
  const getAppointmentDaysList = useSelector(
    (state) => state?.getAppointmentDaysReducer?.data?.data
  );
  const getAppointmentDaysLoading = useSelector(
    (state) => state?.getAppointmentDaysReducer?.loading
  );

  const [tabData, setTabData] = useState(
    () =>
      getAppointmentDaysList?.map((key) => ({
        label: key?.name?.slice(0, 3),
        slug: key?.slug,
        isHoliday: false,
        shift: { start: '', end: '' },
        breaks: [],
        isShow: false,
      })) || []
  );

  const handleTabChange = (val) => {
    setCopyValue('');
    setTab(val);
  };

  ////////////TabShiftDetails/////////////////////////

  function convertTo24HourFormat(time12h) {
    return moment(time12h, ['h:mm A']).format('HH:mm');
  }

  const [tabDetails, setTabDetails] = useState(() => {
    if (getAppointmentsData?.length > 0) {
      return tabData.map((tab) => {
        const matchingAppointment = getAppointmentsData.find(
          (appointment) => appointment?.day_of_week?.slug === tab.slug
        );
        const matchingAppointmentIndex = getAppointmentsData.findIndex(
          (appointment) => appointment?.day_of_week?.slug === tab.slug
        );
        if (matchingAppointment) {
          return {
            ...tab,
            isHoliday:
              getAppointmentsData?.[matchingAppointmentIndex]?.is_holiday,
            id: getAppointmentsData?.[matchingAppointmentIndex]?.id,
            shift: {
              start: convertTo24HourFormat(
                getAppointmentsData?.[matchingAppointmentIndex]?.start_time
              ),
              end: convertTo24HourFormat(
                getAppointmentsData?.[matchingAppointmentIndex]?.end_time
              ),
            },
            breaks: getAppointmentsData?.[
              matchingAppointmentIndex
            ]?.schedule_breaks?.map((bItem) => ({
              break_start_time: convertTo24HourFormat(bItem?.break_start_time),
              break_end_time: convertTo24HourFormat(bItem?.break_end_time),
            })) || [{ break_start_time: '', break_end_time: '' }],
            isShow: true,
          };
        }
        return tab;
      });
    }
    return tabData;
  });

  useEffect(() => {
    if (getAppointmentDaysList?.length && selectedDay) {
      const index = getAppointmentDaysList.findIndex(
        (obj) => obj.name === selectedDay
      );
      if (index !== -1) {
        setTab(index);
        if (state?.copyValue !== undefined) {
          const copyIndex = getAppointmentDaysList?.findIndex(
            (obj) => obj.slug === state?.copyValue?.slug
          );
          const appointmentDataIndex = getAppointmentsData?.findIndex(
            (obj) => obj?.day_of_week?.slug === state?.copyValue?.slug
          );

          const updatedDetails = [...tabDetails];
          updatedDetails[copyIndex].isHoliday =
            getAppointmentsData?.[appointmentDataIndex]?.is_holiday;
          updatedDetails[copyIndex].id =
            getAppointmentsData?.[appointmentDataIndex]?.id;
          updatedDetails[copyIndex].shift = {
            start: convertTo24HourFormat(
              getAppointmentsData?.[appointmentDataIndex]?.start_time
            ),
            end: convertTo24HourFormat(
              getAppointmentsData?.[appointmentDataIndex]?.end_time
            ),
          };
          updatedDetails[copyIndex].breaks = getAppointmentsData?.[
            appointmentDataIndex
          ]?.schedule_breaks?.map((bItem) => ({
            break_start_time: convertTo24HourFormat(bItem?.break_start_time),
            break_end_time: convertTo24HourFormat(bItem?.break_end_time),
          })) || [{ break_start_time: '', break_end_time: '' }];
          updatedDetails[copyIndex].isShow = true;
          setCopyValue(updatedDetails?.[copyIndex]);
          handleCopyAppointments(updatedDetails?.[copyIndex], index);
        } else {
          handleCreateAppointments('', index);
        }
      }
    }
  }, [getAppointmentDaysList]);

  const handleShiftChange = (tabIndex, field, value) => {
    const updatedDetails = [...tabDetails];
    updatedDetails[tabIndex].shift[field] =
      value === 'Invalid date' ? '' : value;
    setTabDetails(updatedDetails);
  };

  const handleBreakChange = (tabIndex, breakIndex, field, value) => {
    const updatedDetails = [...tabDetails];
    updatedDetails[tabIndex].breaks[breakIndex][field] = value;
    setTabDetails(updatedDetails);
  };

  const handleAddBreak = (tabIndex) => {
    const updatedDetails = [...tabDetails];
    updatedDetails[tabIndex].breaks.push({
      break_start_time: '',
      break_end_time: '',
    });
    setTabDetails(updatedDetails);
  };

  const handleRemoveBreak = (tabIndex, breakIndex) => {
    const updatedDetails = [...tabDetails];
    updatedDetails?.[tabIndex]?.breaks?.splice(breakIndex, 1);
    setTabDetails(updatedDetails);
  };

  const handleSaveDetails = (tabValue) => {
    const indicesToSave = tabDetails.findIndex(
      (tab) => tab.label === tabValue.label
    );

    const start = tabDetails?.[indicesToSave]?.shift?.start;
    const end = tabDetails?.[indicesToSave]?.shift?.end;
    const brk = tabDetails?.[indicesToSave]?.breaks;

    if (!tabDetails[indicesToSave]?.isHoliday) {
      if (start === '' && end === '') {
        return setConf({
          msg: 'Start time and End time must be filled',
          variant: 'error',
        });
      }
    }

    if (start && end && end <= start) {
      return setConf({
        msg: 'End time must be greater than start time',
        variant: 'error',
      });
    }

    if (brk?.length > 0) {
      for (let i = 0; i < brk?.length; i++) {
        if (
          brk?.[i] &&
          (brk?.[i]?.break_start_time <= start ||
            brk?.[i]?.break_end_time >= end ||
            brk?.[i]?.break_end_time <= brk?.[i]?.break_start_time)
        ) {
          return setConf({
            msg: `Break ${i + 1} time must be between start and end time, and end time must be greater than start time`,
            variant: 'error',
          });
        }
      }
    }

    if (tabDetails?.[indicesToSave]?.id) {
      let body = {
        is_holiday: tabDetails[indicesToSave]?.isHoliday,
        day_of_week: tabDetails[indicesToSave]?.slug,
      };
      if (!tabDetails[indicesToSave]?.isHoliday) {
        body.start_time = tabDetails?.[indicesToSave]?.shift?.start;
        body.end_time = tabDetails?.[indicesToSave]?.shift?.end;
        body.schedule_breaks = tabDetails?.[indicesToSave]?.breaks;
      }

      dispatch(
        updateAppointmentsCallAPI(body, {
          id: tabDetails?.[indicesToSave]?.id,
          navigate: navigate,
          run: true,
          handleFunction: (res) => handleSuccess(res),
          toast: true,
          handleToastError: (res) => handleError(res),
        })
      );
    } else {
      let body = {
        schedules: [
          {
            is_holiday: tabDetails[indicesToSave]?.isHoliday,
            day_of_week: tabDetails[indicesToSave]?.slug,
          },
        ],
      };
      if (!tabDetails[indicesToSave]?.isHoliday) {
        body.schedules[0].start_time =
          tabDetails?.[indicesToSave]?.shift?.start;
        body.schedules[0].end_time = tabDetails?.[indicesToSave]?.shift?.end;
        body.schedules[0].schedule_breaks = tabDetails?.[indicesToSave]?.breaks;
      }
      dispatch(
        addAppointmentsCallAPI(body, {
          navigate: navigate,
          run: true,
          handleFunction: (res) => handleSuccess(res),
          toast: true,
          handleToastError: (res) => handleError(res),
        })
      );
    }
  };

  const handleSuccess = (res) => {
    setConf({
      msg: res?.data?.message,
      variant: 'success',
    });

    getAppointmentsList();
  };

  const getAppointmentsList = () => {
    dispatch(
      getAppointmentsCallAPI(
        {},
        {
          run: true,
          handleFunction: (res) => handleAppointmentsListSuccess(res),
          navigate: navigate,
        }
      )
    );
  };

  const handleAppointmentsListSuccess = (res) => {
    setAppointmentsListData(res?.data?.data);
  };

  const handleError = (res) => {
    setConf({
      msg: res?.data?.message,
      variant: 'error',
    });
  };

  const handleCreateAppointments = (tabValue, tabIndex) => {
    const updatedDetails = [...tabDetails];
    updatedDetails[tabIndex].isShow = true;
    setTabDetails(updatedDetails);
  };

  const handleCopyAppointments = (copyValue, tabIndex) => {
    if (copyValue) {
      const updatedDetails = [...tabDetails];
      updatedDetails[tabIndex].isShow = true;
      updatedDetails[tabIndex].isHoliday = copyValue?.isHoliday;
      setTabDetails(updatedDetails);
      handleShiftChange(tabIndex, 'start', copyValue?.shift?.start);
      handleShiftChange(tabIndex, 'end', copyValue?.shift?.end);

      if (copyValue?.breaks?.length > 0) {
        updatedDetails[tabIndex].breaks = [];
        copyValue.breaks.forEach((k, i) => {
          handleAddBreak(tabIndex);
          setTimeout(() => {
            handleBreakChange(
              tabIndex,
              i,
              'break_start_time',
              k?.break_start_time
            );
            handleBreakChange(tabIndex, i, 'break_end_time', k?.break_end_time);
          }, 0);
        });
      }
    }
  };

  const handleInputChange = (e) => {
    setCopyValue(e?.target?.value);
  };

  const tabShiftDetails = (tabValue, tabIndex) => {
    const currentTabDetails = tabDetails[tabIndex];
    const isHolidayDisabled = currentTabDetails.isHoliday ? 'opacity-50' : '';

    return (
      <>
        {currentTabDetails?.isShow ? (
          <>
            <div className="mt-3">
              <CheckBoxInput
                label={<FormattedMessage id="Mark as Holiday" />}
                size="14"
                fontWeight="500"
                onChange={(e) => {
                  const updatedDetails = [...tabDetails];
                  updatedDetails[tabIndex].isHoliday = e.target.checked;
                  setTabDetails(updatedDetails);
                }}
                checked={currentTabDetails.isHoliday}
              />
            </div>

            <h3
              className={`p-0 m-0 mt-4 fs-16 fc-292D32 ff-Akkurat_Bold ${isHolidayDisabled}`}
            >
              <FormattedMessage id="Shift Details" />
            </h3>

            <Row className={`m-0 p-0 ${isHolidayDisabled}`}>
              <Col md={12} lg={6} className="">
                <LabelWithInput
                  label={<FormattedMessage id="Start Time" />}
                  type="time"
                  value={currentTabDetails.shift.start}
                  disabled={currentTabDetails.isHoliday}
                  onChange={(e) =>
                    handleShiftChange(tabIndex, 'start', e.target.value)
                  }
                />
              </Col>

              <Col md={12} lg={6} className="">
                <LabelWithInput
                  label={<FormattedMessage id="End Time" />}
                  type="time"
                  value={currentTabDetails.shift.end}
                  disabled={currentTabDetails.isHoliday}
                  onChange={(e) =>
                    handleShiftChange(tabIndex, 'end', e.target.value)
                  }
                />
              </Col>
            </Row>

            {userRole !== 'salon-admin' && userRole !== 'branch-company' && (
              <h3
                className={`p-0 m-0 mt-4 fs-16 fc-292D32 ff-Akkurat_Bold ${isHolidayDisabled}`}
              >
                <FormattedMessage id="Break(s)" />
              </h3>
            )}

            <Row className={`m-0 p-0 ${isHolidayDisabled}`}>
              {currentTabDetails.breaks.map((breakTime, index) => (
                <>
                  <div className="flex justify-between align-center mt-4">
                    <h3 className="p-0 m-0  fs-14 fc-292D32 ff-Akkurat ">
                      <FormattedMessage id={`Break`} />
                      {index + 1}
                    </h3>
                    <img
                      src={DeleteIcon}
                      className="cursor-pointer"
                      style={{ height: '24px', width: '24px' }}
                      onClick={() => handleRemoveBreak(tabIndex, index)}
                    />
                  </div>

                  <Col md={12} lg={6} className="">
                    <LabelWithInput
                      label={<FormattedMessage id="Start Time" />}
                      type="time"
                      format="h:mm a"
                      value={breakTime.break_start_time}
                      disabled={currentTabDetails.isHoliday}
                      onChange={(e) =>
                        handleBreakChange(
                          tabIndex,
                          index,
                          'break_start_time',
                          e.target.value
                        )
                      }
                    />
                  </Col>

                  <Col md={12} lg={6} className="">
                    <LabelWithInput
                      label={<FormattedMessage id="End Time" />}
                      type="time"
                      format="h:mm a"
                      value={breakTime.break_end_time}
                      disabled={currentTabDetails.isHoliday}
                      onChange={(e) =>
                        handleBreakChange(
                          tabIndex,
                          index,
                          'break_end_time',
                          e.target.value
                        )
                      }
                    />
                  </Col>
                </>
              ))}
            </Row>

            {userRole !== 'salon-admin' && userRole !== 'branch-company' && (
              <Row className={`m-0 p-0 mt-3 ${isHolidayDisabled}`}>
                <ReusableButton
                  fullWidth={false}
                  variant="outlined"
                  color="#1A1A1A"
                  fontSize="14px"
                  fontWeight="500"
                  padding="12px 25px"
                  height="40px"
                  bgColor="transparent"
                  brColor="#DDDDDD"
                  fontFamily="Akkuat"
                  disabled={currentTabDetails.isHoliday}
                  onClick={() => handleAddBreak(tabIndex)}
                >
                  <img
                    src={AddIcon}
                    alt="icon"
                    style={{ height: '24px', width: '24px' }}
                    className="me-2"
                  />
                  <FormattedMessage id="Add break" />
                </ReusableButton>
              </Row>
            )}

            <Row className="m-0 p-0 mt-4 flex text-end items-center justify-end">
              <Stack
                direction="horizontal"
                gap={2}
                className="items-center justify-end p-0"
              >
                <ReusableButton
                  fullWidth={false}
                  variant="outlined"
                  color="#1A1A1A"
                  fontSize="16px"
                  fontWeight="400"
                  padding="12px 50px"
                  height="44px"
                  bgColor="transparent"
                  brColor="#DDDDDD"
                  fontFamily="Akkurat"
                  onClick={() => navigate(-1)}
                >
                  <FormattedMessage id="Cancel" />
                </ReusableButton>

                <ReusableButton
                  fullWidth={false}
                  variant="contained"
                  color="#FFFFFF"
                  fontSize="16px"
                  fontWeight="400"
                  padding="12px 50px"
                  height="44px"
                  bgColor="#1A1A1A"
                  brColor="#1A1A1A"
                  fontFamily="Akkurat"
                  endIcon={
                    (addAppointmentLoader || updateAppointmentLoader) && (
                      <CircularProgress
                        style={{
                          color: 'white',
                          width: '20px',
                          height: '20px',
                        }}
                      />
                    )
                  }
                  onClick={() => handleSaveDetails(tabValue)}
                >
                  <FormattedMessage id="Save" />
                </ReusableButton>
              </Stack>
            </Row>
          </>
        ) : (
          <>
            <div className="flex-col items-center justify-center text-center mt-5 pt-5 mb-5 pb-5">
              <div className="mt-5 pt-5">
                <p className="p-0 m-0 fs-16 fc-#1A1A1A ff-Akkurat">
                  <FormattedMessage id="Show your availability to the customer" />
                </p>
              </div>
              <div className="mt-4 mb-5 pb-5 flex gap-4 justify-center">
                <ReusableButton
                  fullWidth={false}
                  variant="contained"
                  color="#FFFFFF"
                  fontSize="16px"
                  fontWeight="400"
                  padding="12px 50px"
                  height="50px"
                  bgColor="#1A1A1A"
                  brColor="#1A1A1A"
                  fontFamily="Akkurat"
                  onClick={() => handleCreateAppointments(tabValue, tabIndex)}
                >
                  <img
                    src={AddIcon}
                    alt="icon"
                    style={{ height: '24px', width: '24px' }}
                    className="me-2"
                  />
                  <FormattedMessage id="Create New" />
                </ReusableButton>

                {getAppointmentsData?.length > 0 && (
                  <div
                    className="flex gap-4 justify-center"
                    style={{ width: '350px' }}
                  >
                    <ReusableButton
                      fullWidth={false}
                      variant="contained"
                      color="#FFFFFF"
                      fontSize="16px"
                      fontWeight="400"
                      padding="12px 50px"
                      height="50px"
                      bgColor="#1A1A1A"
                      brColor="#1A1A1A"
                      fontFamily="Akkurat"
                      onClick={() =>
                        handleCopyAppointments(copyValue, tabIndex)
                      }
                    >
                      <FormattedMessage id="Copy" />
                    </ReusableButton>

                    <SelectInput
                      marginLabelTop={'0'}
                      marginTop={'0'}
                      placeholder={intl.formatMessage({
                        id: 'Select a day',
                      })}
                      value={copyValue && copyValue?.label}
                      data={
                        tabDetails
                          ? tabDetails?.filter((k) => k?.isShow === true)
                          : []
                      }
                      onChange={(e) => handleInputChange(e)}
                    />
                  </div>
                )}
              </div>
            </div>
          </>
        )}
      </>
    );
  };

  ////////////TabShiftDetails/////////////////////////

  return (
    <Row className="bc-F2F3F6 m-0 p-0">
      <Col>
        <div className="flex gap-4 p-0 mt-3">
          <Row className="p-0 m-0 w-100">
            <Col
              md={12}
              lg={12}
              className=" border-1 bColor-FFFFFF bc-FFFFFF p-4"
            >
              <p className="p-0 m-0 fs-20 fc-#1A1A1A ff-Akkurat_Bold ">
                <FormattedMessage id="Edit Timings" />
              </p>

              {getAppointmentDaysLoading ||
              getAppointmentsLoading ||
              !getAppointmentDaysList?.length ? (
                <>
                  <div className="mt-3 w-100">
                    <div className="flex gap-2">
                      {[1, 2, 3, 4, 5, 6, 7].map((item) => (
                        <ShimmerBox
                          key={item}
                          width="120px"
                          height="44px"
                          style={{ borderRadius: '4px' }}
                        />
                      ))}
                    </div>
                  </div>
                  <div className="mt-4">
                    <ShimmerBox width="150px" height="18px" />
                    <Row className="m-0 p-0 mt-4">
                      <Col md={12} lg={6}>
                        <ShimmerBox
                          width="100px"
                          height="16px"
                          className="mb-2"
                        />
                        <ShimmerBox width="100%" height="44px" />
                      </Col>
                      <Col md={12} lg={6}>
                        <ShimmerBox
                          width="100px"
                          height="16px"
                          className="mb-2"
                        />
                        <ShimmerBox width="100%" height="44px" />
                      </Col>
                    </Row>
                    {userRole !== 'salon-admin' &&
                      userRole !== 'branch-company' && (
                        <>
                          <ShimmerBox
                            width="120px"
                            height="18px"
                            className="mt-4"
                          />
                          <Row className="m-0 p-0 mt-3">
                            <Col md={12} lg={6}>
                              <ShimmerBox
                                width="100px"
                                height="16px"
                                className="mb-2"
                              />
                              <ShimmerBox width="100%" height="44px" />
                            </Col>
                            <Col md={12} lg={6}>
                              <ShimmerBox
                                width="100px"
                                height="16px"
                                className="mb-2"
                              />
                              <ShimmerBox width="100%" height="44px" />
                            </Col>
                          </Row>
                        </>
                      )}
                    <div className="flex justify-end mt-4 gap-2">
                      <ShimmerBox width="100px" height="44px" />
                      <ShimmerBox width="100px" height="44px" />
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <div className="mt-3 w-100">
                    <CustomTabs
                      tabs={tabData}
                      value={tab}
                      tabData={tabDetails}
                      onChange={handleTabChange}
                      tabStyles={{
                        fontSize: '18px',
                        color: '#787878',
                        selectedColor: '#1A1A1A ',
                      }}
                      indicatorColor="#1A1A1A"
                    />
                  </div>

                  {tabData.map((k, i) => tab === i && tabShiftDetails(k, i))}
                </>
              )}
            </Col>
          </Row>
        </div>
      </Col>
    </Row>
  );
};

export default EditSchdeule;
